module.exports = __webpack_public_path__ + "img/Refresh - Gray.d478bf2e.png";